import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faSliders } from "@fortawesome/free-solid-svg-icons";
import { getAllResources } from "../../../components/ResourcesPage/resourcesData";

const ImagePlaceholder = () => (
  <div className="w-full h-44 bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
    <svg className="w-12 h-12 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
      <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
    </svg>
  </div>
);

function ResourceSubTab({ title, categories }) {
  const [search, setSearch] = useState("");

  const allResources = getAllResources();
  const filtered = allResources.filter((r) => {
    const matchesCategory = categories.includes(r.category);
    const matchesSearch = r.title.toLowerCase().includes(search.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="flex-1 bg-gray-100 min-h-screen p-8">
      {/* Title */}
      <h1 className="!text-[30px] !font-semibold !font-poppins text-blue-navy mb-4 text-left">{title}</h1>

      {/* Search + Filter */}
      <div className="flex items-center gap-3 mb-8 max-w-2xl">
        <div className="flex items-center gap-3 bg-white border border-gray-400 rounded-full px-5 py-[2px] flex-1">
          <FontAwesomeIcon icon={faMagnifyingGlass} className="text-gray-400" size="sm" />
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="flex-1 outline-none border-none bg-transparent text-sm text-gray-700 placeholder-gray-400 py-2"
          />
        </div>
        <button className="flex items-center gap-2 border border-gray-300 rounded-full px-4 py-2 text-sm text-gray-700 bg-white hover:bg-gray-50 whitespace-nowrap">
          <FontAwesomeIcon icon={faSliders} size="sm" />
          Filter
        </button>
      </div>

      {/* Cards Grid */}
      {filtered.length > 0 ? (
        <div className="grid grid-cols-4 gap-5">
          {filtered.map((resource) => (
            <div key={resource.id} className="bg-white rounded-2xl overflow-hidden shadow-sm flex flex-col">
              {resource.image ? (
                <img src={resource.image} alt={resource.title} className="w-full h-44 object-cover" />
              ) : (
                <ImagePlaceholder />
              )}
              <div className="p-4 flex flex-col flex-1 text-left">
                <p className="!font-bold !text-sm text-orange mb-2 leading-snug">{resource.title}</p>
                <p className="!text-xs text-gray-500 mb-4 flex-1 leading-relaxed">{resource.description}</p>
                <a
                  href={resource.downloadUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="!text-xs !font-semibold text-gray-900 flex items-center gap-1 hover:underline"
                >
                  Get the freebie →
                </a>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-400 text-sm">No resources found.</p>
      )}
    </div>
  );
}

export default ResourceSubTab;
